import type { StepProps, Country } from '@/types/apply'

interface StepPersonalProps extends StepProps {
  countries: Country[]
}

export default function StepPersonal({ formData, updateField, errors, clearError, countries }: StepPersonalProps) {
  const p = formData.personal_info

  return (
    <div className="space-y-5">
      <div className="grid gap-5 sm:grid-cols-2">
        <div>
          <label className="apply-label">First Name</label>
          <input
            type="text"
            className={`apply-input ${errors.first_name ? 'apply-input-error' : ''}`}
            placeholder="John"
            value={p.first_name}
            onChange={e => { updateField('personal_info', 'first_name', e.target.value); clearError('first_name') }}
            autoFocus
          />
          {errors.first_name && <p className="apply-error-text">{errors.first_name}</p>}
        </div>
        <div>
          <label className="apply-label">Last Name</label>
          <input
            type="text"
            className={`apply-input ${errors.last_name ? 'apply-input-error' : ''}`}
            placeholder="Doe"
            value={p.last_name}
            onChange={e => { updateField('personal_info', 'last_name', e.target.value); clearError('last_name') }}
          />
          {errors.last_name && <p className="apply-error-text">{errors.last_name}</p>}
        </div>
      </div>

      <div>
        <label className="apply-label">Email</label>
        <input
          type="email"
          className={`apply-input ${errors.email ? 'apply-input-error' : ''}`}
          placeholder="john@example.com"
          value={p.email}
          onChange={e => { updateField('personal_info', 'email', e.target.value); clearError('email') }}
        />
        {errors.email && <p className="apply-error-text">{errors.email}</p>}
      </div>

      <div>
        <label className="apply-label">Phone Number</label>
        <div className="flex gap-2">
          <div className="w-28 flex-shrink-0 sm:w-32">
            <select
              className="apply-input"
              value={p.phone_iso_code}
              onChange={e => {
                const country = countries.find(c => c.code === e.target.value)
                if (country) {
                  updateField('personal_info', 'phone_iso_code', country.code)
                  updateField('personal_info', 'phone_dial_code', country.dial_code)
                }
              }}
            >
              {countries.map(c => (
                <option key={c.code} value={c.code}>
                  {c.flag} +{c.dial_code}
                </option>
              ))}
            </select>
          </div>
          <div className="min-w-0 flex-1">
            <input
              type="tel"
              className={`apply-input ${errors.phone ? 'apply-input-error' : ''}`}
              placeholder="Phone number"
              value={p.phone}
              onChange={e => { updateField('personal_info', 'phone', e.target.value.replace(/[^\d]/g, '')); clearError('phone') }}
            />
          </div>
        </div>
        {errors.phone && <p className="apply-error-text">{errors.phone}</p>}
      </div>

      <div>
        <label className="apply-label">
          Website <span className="text-white/30">(optional)</span>
        </label>
        <input
          type="url"
          className={`apply-input ${errors.website ? 'apply-input-error' : ''}`}
          placeholder="https://yourwebsite.com"
          value={p.website}
          onChange={e => { updateField('personal_info', 'website', e.target.value); clearError('website') }}
        />
        {errors.website && <p className="apply-error-text">{errors.website}</p>}
      </div>
    </div>
  )
}
